export const tab_list = ["DELIVERY", "PAYMENT DEPOSIT", "PAYMENT BILL", "REJECTED ITEMS", "JOURNAL", "LOGBOOK", "OTHERS"]